export const URL_FORMAT_REFERENCE = '/valueLists/FLEX_VALUE_ALL?sublistCode=TABLE_REPORT_DOWNLOAD_FORMAT';
export const URL_PROGRAMS_REFERENCE = '/valueLists/MONITOR_PROGRAM';
